import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function InternationalBusinessInquiries() {
  return <section id="international-business-inquiries" className="dark bg-background text-foreground py-[80px] md:py-[120px] px-6">
      <div className="container mx-auto max-w-4xl flex flex-col items-center text-center">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight mb-6">
          Global Distribution & Partnerships
        </h2>
        <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-3xl leading-relaxed">
          As a Victorian-registered proprietary company, HSINHUI COSMETICS PTY LTD is positioned for international excellence.
        </p>
        <Button asChild variant="outline" size="lg" className="border-2 border-foreground text-foreground bg-transparent hover:bg-foreground hover:text-background rounded-none px-10 py-7 text-sm md:text-base uppercase tracking-[0.15em] transition-colors duration-300">
          <Link to="/ContactUsPage">
            Contact our Corporate Office
          </Link>
        </Button>
      </div>
    </section>;
}